import { Geometry } from "../../drawing/Geometry";
import { PrintBehavior } from "./PrintBehavior";

export interface IDrawable {
  isVisible: boolean;           // 編集表示要否.
  printBehavior: PrintBehavior; // 印刷時の振る舞い.
  geometry: Geometry;
}

export function instanceOfIDrawable(instance: any): instance is IDrawable {
  return instance
    && (instance.isVisible !== undefined)
    && (instance.printBehavior !== undefined)
    && (instance.geometry !== undefined);
}
